export function HowItWorks() {
  const steps = [
    {
      icon: 'ri-t-shirt-line',
      step: '01',
      title: 'Pick Your Shirt',
      desc: 'Choose from premium blank tees in white, gray, cream, or camo. Soft, durable, and print-ready.',
    },
    {
      icon: 'ri-edit-2-line',
      step: '02',
      title: 'Customize Your Design',
      desc: 'Add text, upload graphics, pick fonts and colors. Our live studio shows every change in real time.',
    },
    {
      icon: 'ri-map-pin-2-line',
      step: '03',
      title: 'Printed in Starkville',
      desc: 'Your order is printed locally right here in Starkville, MS — fast turnaround, quality you can feel.',
    },
  ];

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-red-50 text-[#6B0000] text-xs font-bold uppercase tracking-widest rounded-full mb-4">
            Simple Process
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto">
            From blank shirt to your door — three easy steps, all done locally.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          <div className="hidden md:block absolute top-12 left-1/3 right-1/3 h-0.5 bg-gradient-to-r from-[#6B0000]/20 via-[#6B0000]/60 to-[#6B0000]/20"></div>

          {steps.map((s, i) => (
            <div key={i} className="relative flex flex-col items-center text-center group">
              <div className="relative mb-6">
                <div className="w-24 h-24 flex items-center justify-center bg-[#6B0000] rounded-2xl shadow-lg group-hover:scale-105 transition-transform duration-300">
                  <i className={`${s.icon} text-white text-4xl`}></i>
                </div>
                <span className="absolute -top-3 -right-3 w-8 h-8 flex items-center justify-center bg-white border-2 border-[#6B0000] text-[#6B0000] text-xs font-black rounded-full shadow">
                  {s.step}
                </span>
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3">{s.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed max-w-xs">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
